<template>
  <div class="px-4 flex items-center">
    <Btn
      class="mr-2"
      :color="BtnColor.SECONDARY"
      :size="BtnSize.SM"
      icon
      @click="emit('back')"
    >
      <Icon :icon="ArrowLeftCircleSvg" />
    </Btn>
    <h2 v-if="title" class="text-xl font-bold text-secondary">
      {{ props.title }}
    </h2>
  </div>
</template>

<script setup lang="ts">
import { Btn, BtnSize, BtnColor } from '~/components/btn';
import { Icon } from '~/components/icon';
import ArrowLeftCircleSvg from '~/assets/icons/arrow-left-circle.svg?component';

type Props = {
  title?: string;
};
const props = defineProps<Props>();
const emit = defineEmits(['back']);
</script>
